// Array polyfills.
import 'core-js/fn/array/find';
import 'core-js/fn/array/find-index';
import 'core-js/fn/array/from';
import 'core-js/fn/array/includes';

// String polyfills.
import 'core-js/fn/string/includes';

import React from 'react';
import ReactDOM from 'react-dom';
import URLSearchParams from 'url-search-params';
import store from 'store2';

import { Provider } from 'react-redux';
import { createDevTools } from 'redux-devtools';
import { compose, createStore, applyMiddleware } from 'redux';
import { responsiveStoreEnhancer } from 'redux-responsive';
import LogMonitor from 'redux-devtools-log-monitor';
import DockMonitor from 'redux-devtools-dock-monitor';
import thunk from 'redux-thunk';
import { BrowserRouter, Route } from 'react-router-dom';
import Raven from 'raven-js';
import createRavenMiddleware from 'raven-for-redux';

import apiRequestMiddleware from './common/utils/apiRequestMiddleware';
import ScrollToTop from './common/components/ScrollToTop';
import config from './config';
import reducers from './redux/reducers';
import App from './App';
import './index.css';

Raven.config('https://d14b9b75d03d407395ae925b70c5d077@sentry.io/233292', {
  ignoreErrors: [
    'Blocked a frame with origin "https://app.tathatagolf.com" from accessing a frame with origin "https://b.frstre.com". Protocols, domains, and ports must match.',
  ],
}).install();
Raven.setTagsContext({
  environment: config.sentryEnvironmentTag,
});

const gtag = window.gtag;
const gaKey = config.googleAnalyticsKey;
const adWordsKey = config.adWordsKey;

// Polyfill URLSearchParams so fetch-client works in IE
window.URLSearchParams = URLSearchParams;

// Apply Redux middleware
let storeEnhancer = compose(
  responsiveStoreEnhancer,
  applyMiddleware(apiRequestMiddleware, thunk, createRavenMiddleware(Raven))
);

// Apply Redux DevTools in development only
let DevTools = null;

if (process.env.NODE_ENV === 'development' && false) {
  DevTools = createDevTools(
    <DockMonitor toggleVisibilityKey="ctrl-h" changePositionKey="ctrl-q" defaultIsVisible={false}>
      <LogMonitor theme="tomorrow" />
    </DockMonitor>
  );

  storeEnhancer = compose(storeEnhancer, DevTools.instrument());
}

// Handle auth tokens from OIDC provider, if set
if (window.location.hash) {
  // Parse URL hash of format #foo=bar&stuff=things
  const hashQuery = window.location.hash
    .substring(1)
    .split('&')
    .map(str => str.split('='))
    .reduce((prev, curr) => {
      prev[curr[0]] = curr[1];
      return prev;
    }, {});

  // nonce is only set when frontend requests login/registration
  const nonce = store.get('nonce');

  if (hashQuery.id_token && nonce) {
    let decoded = JSON.parse(atob(hashQuery.id_token.split('.')[1]));

    Raven.setUserContext({
      id: decoded.sub,
    });

    if (nonce === decoded.nonce) {
      store.set('code', hashQuery.code);
      store.set('idToken', hashQuery.id_token);
      store.set('accessToken', hashQuery.access_token);
      store.remove('nonce');
    }
  }

  // Remove URL hash while maintaining history and query string
  history.replaceState('', document.title, window.location.pathname + window.location.search);
}

window.Stripe.setPublishableKey(config.stripe.publishableKey);

// G-tag setup.
gtag('js', new Date());
gtag('config', gaKey);
gtag('config', adWordsKey);

// Tapfiliate setup
window.tap('create', config.tapfiliateKey);
window.tap('detect');

// Bootstrap the React app
const reduxStore = storeEnhancer(createStore)(reducers);
ReactDOM.render(
  <Provider store={reduxStore}>
    <BrowserRouter>
      <ScrollToTop>
        <div>
          <Route component={App} />
          <Route component={DevTools} />
        </div>
      </ScrollToTop>
    </BrowserRouter>
  </Provider>,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js